import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const CallIncoming = () => (
  <ImageIcon src={Images.CallIncoming} alt="Call Incoming" />
);

export default CallIncoming;
